import { graphql } from 'gql';

export const uerPriceListUerForDismantlingRatioUerCodeFilter = graphql(`
    query uerPriceListUerForDismantlingRatioUerCodeFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $groupType: DismantlingCoefficientTypeEnum
        $rationRowId: Long
        $preselectedUerBaseRowIds: [Long!]
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerPriceListUerForDismantlingRatioUerCodeFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            groupType: $groupType
            rationRowId: $rationRowId
            preselectedUerBaseRowIds: $preselectedUerBaseRowIds
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerPriceListUerForDismantlingRatioUerNameFilter = graphql(`
    query uerPriceListUerForDismantlingRatioUerNameFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $groupType: DismantlingCoefficientTypeEnum
        $rationRowId: Long
        $preselectedUerBaseRowIds: [Long!]
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerPriceListUerForDismantlingRatioUerNameFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            groupType: $groupType
            rationRowId: $rationRowId
            preselectedUerBaseRowIds: $preselectedUerBaseRowIds
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerPriceListUerForDismantlingRatioUerGroupFilter = graphql(`
    query uerPriceListUerForDismantlingRatioUerGroupFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $groupType: DismantlingCoefficientTypeEnum
        $rationRowId: Long
        $preselectedUerBaseRowIds: [Long!]
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerPriceListUerForDismantlingRatioUerGroupFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            groupType: $groupType
            rationRowId: $rationRowId
            preselectedUerBaseRowIds: $preselectedUerBaseRowIds
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerPriceListUerForDismantlingRatioUerUnitFilter = graphql(`
    query uerPriceListUerForDismantlingRatioUerUnitFilter(
        $skip: Int
        $take: Int
        $contractId: Long!
        $groupType: DismantlingCoefficientTypeEnum
        $rationRowId: Long
        $preselectedUerBaseRowIds: [Long!]
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerPriceListUerForDismantlingRatioUerUnitFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            groupType: $groupType
            rationRowId: $rationRowId
            preselectedUerBaseRowIds: $preselectedUerBaseRowIds
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
